import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgBookmark(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.75 4C5.75 3.30964 6.30964 2.75 7 2.75H25C25.6904 2.75 26.25 3.30964 26.25 4V28C26.25 28.461 25.9963 28.8846 25.5898 29.1021C25.1834 29.3196 24.6902 29.2958 24.3066 29.0401L16 23.5023L7.69338 29.0401C7.3098 29.2958 6.81662 29.3196 6.41018 29.1021C6.00373 28.8846 5.75 28.461 5.75 28V4ZM8.25 5.25V25.6644L15.3066 20.9599C15.7265 20.68 16.2735 20.68 16.6934 20.9599L23.75 25.6644V5.25H8.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBookmark);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
